import { useLocation } from "react-router-dom";
import { extractRoomIdFromPath } from "../utils/roomIdFromPath";

/**
 * The room a share made from this page belongs to, or null outside a room.
 *
 * Read from the PATH, and not passed down. The four share hooks are called from
 * thirteen places: article pages, playlist pages, video and infographic pages,
 * and the cards on every feed. In all thirteen the answer is the same fact, the
 * room in the current URL, which is what `RoomRoutes` itself reads to decide
 * what to render. A prop would be thirteen chances to forget it, and forgetting
 * it is the defect this exists to end: a share from inside a room minted a
 * public link, so the reader lost the room their colleague was reading in.
 *
 * It is right for a card as well as for a page. A card on `/discovery` shares
 * the public link even when the article also sits in a room, because the sender
 * was not in that room. The same card on `/room/discovery/:roomId` shares the
 * room link. The path is what separates those two, and nothing else can.
 */
export function useShareRoomId(): string | null {
  const { pathname } = useLocation();
  return extractRoomIdFromPath(pathname);
}
